import { BonusAndDeductionRules as BonusAndDeductionRulesWebsite } from "../pages/web/settings/subpages/BonusAndDeductionRules";
import { BonusAndDeductionRules as BonusAndDeductionRulesMobile } from "../pages/mobile/settings/subpages/BonusAndDeductionRules";
import { BreakRules as BreakRulesWebsite } from "../pages/web/settings/subpages/BreakRules";
import { BreakRules as BreakRulesMobile } from "../pages/mobile/settings/subpages/BreakRules";
import { Combinations as CombinationsWebsite } from "../pages/web/settings/subpages/Combinations";
import { Combinations as CombinationsMobile } from "../pages/mobile/settings/subpages/Combinations";
import { Exceptions as ExceptionsWebsite } from "../pages/web/settings/subpages/Exceptions";
import { Exceptions as ExceptionsMobile } from "../pages/mobile/settings/subpages/Exceptions";
import { Overtimes as OvertimesWebsite} from "../pages/web/settings/subpages/Overtimes";
import { Overtimes as OvertimesMobile } from "../pages/mobile/settings/subpages/Overtimes";
import { PayRules as PayRulesWebsite } from "../pages/web/settings/subpages/PayRules";
import { PayRules as PayRulesMobile } from "../pages/mobile/settings/subpages/PayRules";
import { PaycodeCombinations as PaycodeCombinationsWebsite } from "../pages/web/settings/subpages/PaycodeCombinations";
import { PaycodeCombinations as PaycodeCombinationsMobile } from "../pages/mobile/settings/subpages/PaycodeCombinations";
import { PaycodeDistribution as PaycodeDistributionWebsite } from "../pages/web/settings/subpages/PaycodeDistribution";
import { PaycodeDistribution as PaycodeDistributionMobile } from "../pages/mobile/settings/subpages/PaycodeDistribution";
import { Paycodes as PaycodesWebsite } from "../pages/web/settings/subpages/Paycodes";
import { Paycodes as PaycodesMobile } from "../pages/mobile/settings/subpages/Paycodes";
import { Resume as ResumeWebsite } from "../pages/web/settings/subpages/Resume";
import { Resume as ResumeMobile } from "../pages/mobile/settings/subpages/Resume";
import { RoundingRules as RoundingRulesWebsite } from "../pages/web/settings/subpages/RoundingRules";
import { RoundingRules as RoundingRulesMobile } from "../pages/mobile/settings/subpages/RoundingRules";
import { ScheduleDeviation as ScheduleDesviationWebsite } from "../pages/web/settings/subpages/ScheduleDesviation";
import { ScheduleDeviation as  ScheduleDeviationMobile } from "../pages/mobile/settings/subpages/ScheduleDesviation";
import { Zones as ZonesWebsite } from "../pages/web/settings/subpages/Zones";
import { Zones as ZonesMobile } from "../pages/mobile/settings/subpages/Zones";
import { Holidays as HolidaysWebsite } from "../pages/web/settings/subpages/Holidays";
import { WorkRules as WorkRulesWebsite } from "pages/web/settings/subpages/WorkRules";
import { WorkRules as WorkRulesMobile } from "pages/mobile/settings/subpages/WorkRules";
import { FixedRule } from "pages/web/settings/subpages/FixedRule";
import { InterpretationPunchRule } from "../pages/web/settings/subpages/InterpretationPunchRule";
import { CreditHolidayRule } from "../pages/web/settings/subpages/CreditHolidayRule";


const gettingSubPage = (subPage, mobile) => {
    switch (subPage) {
        case 'resume':
            return mobile ? <ResumeMobile /> : <ResumeWebsite />;

        case 'paycodes':
            return mobile ? <PaycodesMobile /> : <PaycodesWebsite />;

        case 'paycode_combinations':
            return mobile ? <PaycodeCombinationsMobile /> : <PaycodeCombinationsWebsite />;

        case 'zones':
            return mobile ? <ZonesMobile /> : <ZonesWebsite />;

        case 'overtimes':
            return mobile ? <OvertimesMobile /> : <OvertimesWebsite />;

        case 'schedule_deviation':
            return mobile ? <ScheduleDeviationMobile /> : <ScheduleDesviationWebsite />;

        case 'combinations':
            return mobile ? <CombinationsMobile /> : <CombinationsWebsite />;

        case 'paycode_distribution':
            return mobile ? <PaycodeDistributionMobile /> : <PaycodeDistributionWebsite />;

        case 'rounding_rules':
            return mobile ? <RoundingRulesMobile /> : <RoundingRulesWebsite />;

        case 'exceptions':
            return mobile ? <ExceptionsMobile /> : <ExceptionsWebsite />;

        case 'break_rules':
            return mobile ? <BreakRulesMobile /> : <BreakRulesWebsite />;

        case 'bonus_and_deduction_rules':
            return mobile ? <BonusAndDeductionRulesMobile /> : <BonusAndDeductionRulesWebsite />;

        case 'pay_rules':
            return mobile ? <PayRulesMobile /> : <PayRulesWebsite />;

        case 'holidays':
            return mobile ? <HolidaysWebsite /> : <HolidaysWebsite />;
        
        case 'fixed_rules':
            return mobile ? <FixedRule /> : <FixedRule />;
        
        case 'interpretation_punch_rule':
            return mobile ? <InterpretationPunchRule /> : <InterpretationPunchRule />;
        
        case 'credit_holiday_rules':
            return mobile ? <CreditHolidayRule /> : <CreditHolidayRule />;

        case 'work_rules':
            return mobile ?  <WorkRulesMobile />: <WorkRulesWebsite />;

        default:
            return <> {`404 Subpage ${subPage} not found`} </>
    }
}

export {
    gettingSubPage
}
